import React from 'react'

const MathContext = React.createContext()

export default MathContext
